import React from 'react'
import styled from 'styled-components'
import { PageHero } from '../components'
import sobreImg from '../assets/hero-bcg.jpeg'

const SobrePage = () => {
  return (
    <main>
      <PageHero title='sobre' />
      <Wrapper className='page section section-center'>
        <img src={sobreImg} alt='nice desk' />
        <article>
          <div className='title'>
            <h2>Nossa História</h2>
            <div className='underline'></div>
          </div>
          <p>
            A Bazzo Decor esta nascendo mas Paulo tapeceiro atua a mais de trinta e sete anos, Ana sua filha administra, Gustavo marido da Ana cuida da logistica e processos para planejamento de estruturas, armações e soldagem, atualmente atendemos varias regiões do Estado de São Paulo, Sorocaba, Valinhos, Campinas, Indaiatuba, Sumaré, Vinhedo, Jundiai, Salto, Itu, Tiete, Boituva, entre outros clientes por todo o Brasil, nossa fabrica esta localizada em Porto Feliz-SP.
          </p>
        </article>
      </Wrapper>
    </main>
  )
}

const Wrapper = styled.section`
  display: grid;
  gap: 4rem;
  img {
    width: 100%;
    display: block;
    border-radius: var(--radius);
    height: 500px;
    object-fit: cover;
  }
  p {
    line-height: 2;
    max-width: 45em;
    margin: 0 auto;
    margin-top: 2rem;
    color: var(--clr-grey-5);
  }
  .title {
    text-align: left;
  }
  .underline {
    margin-left: 0;
  }
  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
`
export default SobrePage
